module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/12-c6d1134c9e4d6cdf65c5157b0bee779d.jpg";